import React, { useState } from 'react'
import HelperString from 'utils/helper-string'
import _ from 'lodash'
import ThemedPressable from 'components/atoms/ThemedPressable'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { styles } from 'scenes/home/coworker/filter/_styles'
import { colorList } from 'utils/colors'
import ListItem from 'components/atoms/ListItem'
import FetchManagementEmployee from 'utils/fetch/management/FetchManagementEmployee'
import { FormFieldsConstants } from 'utils/constants/form-constants'
import i18n from 'utils/i18n'
import Spinner from "theme/Spinner";
import ThemedBlock from 'components/atoms/ThemedBlock'
import Form from 'components/molecules/Form'
import ThemedList from 'components/atoms/ThemedList'

const SearchSelectUserComponent = ({ selectedEmployees = [], subtitle = true, readonly = false, onSubmit }) => {
	
	const [ isSearching, setIsSearching ] = useState( false )
	const [ searchResults, setSearchResults ] = useState( [] )
	const [ newAddedAvailableForEmployees, setNewAddedAvailableForEmployees  ] = useState( selectedEmployees )
	const [ uniqueKey ] = useState( HelperString.random() )
	
	const employeeOptions = [];
	searchResults.forEach( ( employee ) => {
		// Only show items which are not yet selected
		if( typeof _.find( newAddedAvailableForEmployees, { guid: employee.guid } ) === 'undefined' ) {
			let title = employee.name;
			
			if( _.get( employee, [ 'team', 'name' ], null ) !== null ) {
				title = `${title} (${_.get( employee, [ 'team', 'name' ] )})`;
			}
			
			employeeOptions.push({
				title: title,
				data: employee
			});
		}
	})
	
	const renderEmployeeListItem = ( { item, index } ) => {
		let title = item.name;
		
		if( _.get( item, [ 'department', 'name' ], null ) !== null ) {
			title = `${title} (${_.get( item, [ 'department', 'name' ] )})`;
		}
		
		const accessoryRight = readonly ? null : (
			<ThemedPressable
				onPress={ onEmployeeRemove.bind( this, item.guid ) }>
				
				<Icon
					icon={ IconSystemConstants.TRASH }
					style={ [ styles.icon ] }
					color={ colorList.RED.primary }
				/>
			</ThemedPressable>
		);
		
		return (
			<ListItem
				title={ title }
				accessoryRight={ accessoryRight }
			/>
		)
	}
	
	const onEmployeeSelect = ( index ) => {
		const addedAvailableForEmployees = _.cloneDeep( newAddedAvailableForEmployees )
		
		// Check if it's already added
		let added = false;
		
		addedAvailableForEmployees.forEach( ( employee ) => {
			if( employee.guid === employeeOptions[ index ]?.data?.guid ) {
				added = true;
				return false;
			}
		});
		
		if( !added ) {
			addedAvailableForEmployees.push( employeeOptions[ index ].data );
		}
		
		setNewAddedAvailableForEmployees( addedAvailableForEmployees )
	}
	
	const onEmployeeRemove = ( guid ) => {
		const addedAvailableForEmployees = newAddedAvailableForEmployees.filter( item => {
			return item.guid !== guid;
		} );
		
		setNewAddedAvailableForEmployees( addedAvailableForEmployees )
	}
	
	const searchEmployeeChanged = ( value ) => {
		// Always lowercaseee
		value = value?.toLowerCase() ?? '';
		
		// Only when there is a value do a fetch :)
		if( !_.isEmpty( value ) ) {
			FetchManagementEmployee.fetchAll({
				variables: {
					search: value
				},
				callbackStart: setIsSearching.bind( this, true ),
				/* TODO optimize */
				callbackSuccess: ( { employees } ) => {
					setSearchResults( employees )
					setIsSearching( false )
				},
				callbackError: ( result ) => {
					setSearchResults( [] )
					setIsSearching( false )
				}
			})
		}
	}
	
	const saveAvailableForEmployeesForm = ( values, { callback } = {} ) => {
		const employeeGuids = _.map( newAddedAvailableForEmployees, employee => {
			return employee.guid;
		} );
		
		onSubmit( employeeGuids, { callback })
	}
	
	// Create the available for fields
	const formFieldsAvailableEmployeesFor = [
		{
			name: 'search',
			required: true,
			label: i18n.t('management:form.search.title'),
			type: FormFieldsConstants.AUTOCOMPLETE,
			onChangeText: _.debounce( searchEmployeeChanged.bind( this ), 400 ),
			onSelect: onEmployeeSelect,
			options: employeeOptions,
			accessoryRight: isSearching ? () => {
				return <Spinner size='small' color={colorList.PRIMARY.primary} />;
			} : null
		}
	];
	
	return (
		<ThemedBlock
			header={[
				i18n.t('management:form.available_for_employee.title'),
				subtitle === true ? i18n.t('management:form.available_for_employee.description') : null
			]}
			shadow
			mediumPadding>
			
			{ !readonly && (
				<Form
					key={ HelperString.hash( 'form-available-for-employees', uniqueKey ) }
					fields={ formFieldsAvailableEmployeesFor }
					forceSaveButton={ true }
					onSubmit={ saveAvailableForEmployeesForm }
				/>
			)}
			
			<ThemedList
				data={ newAddedAvailableForEmployees }
				renderItem={ renderEmployeeListItem.bind( this ) }
			/>
		</ThemedBlock>
	);
}

export default SearchSelectUserComponent
